export const MinuteOptions = {
    ONE_HOUR: 60,
    ONE_DAY: 60 * 24,
    ONE_WEEK: 60 * 24 * 7,
}